.resolveDifferences {
  > aside {
    flex: 0 0 19.5rem;
    display: flex;
  }

  article {
    section:not([role="alert"] section) {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    [role="alert"] {
      width: calc(37.5rem + 4px);
      align-items: flex-start;
    }

    .description {
      width: 40rem;
      max-width: 40rem;
    }
  }

  .keep {
    color: black;
    background-color: var(--color-success-bg);
  }

  .discard {
    color: var(--gray-500);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='none'%3E%3Cline x1='0' y1='0' x2='100' y2='100' stroke='%23D0D5DD' /%3E%3Cline x1='0' y1='100' x2='100' y2='0' stroke='%23D0D5DD' /%3E%3C/svg%3E");
    background-size: 100% 100%;
  }

  .differencesTable {
    table-layout: fixed;
    margin-bottom: 2.5rem;

    td {
      height: 4.5rem;
    }

    td.gapRow {
      height: 1rem;
    }

    td:not(.gapRow) {
      border-left: 1px solid var(--bg-gray-darkest);
    }
  }

  .zeroDash {
    font-family: var(--font-text);
    color: var(--gray-300);
  }
}
